export default __webpack_public_path__ + "static/media/instagram-icon.50f9d482.svg";